<template>
  <div>
    <v-dialog
      width="1400px"
      :value="PoliceHistory"
      persistent
      content-class="DialogOpenFromTop"
      transition="dialog-top-transition"
      overlay-color="black"
      overlay-opacity="1"
    >
      <v-card tile color="white" class="elevation-0">
        <v-toolbar class="elevation-4" dense color="white">
          <div class="black--text fontsize25px font-weight-bold" align="center">
            Stop History
          </div>
          <v-spacer />
          <v-btn
            v-if="GetActivitiesList.length > 0"
            class="mr-6 black--text"
            outlined
            x-small
            color="black"
            @click.stop="DownloadMyExcel()"
            ><v-icon x-small>mdi-download</v-icon>Download CSV</v-btn
          >
          <v-btn icon @click="HistoryDialogEmit()"
            ><v-icon small color="clack">mdi-close-circle</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-data-table
            dense
            :search="search"
            class="tableClass elevation-0 mt-8"
            :headers="Headers"
            :items="GetActivitiesList"
            :loading="loadnig"
            :hide-default-footer="GetActivitiesList.length == 0"
            :footer-props="{
              'items-per-page-options': [100, 200, 300, 400, 500],
            }"
            fixed-header
          >
            <template v-slot:no-results>
              <v-alert :value="true" class="black--text">
                No records found!
              </v-alert>
            </template>
            <template v-slot:[`item.sl_no`]="{ item }">
              <div class="fontsize12px">
                {{ GetActivitiesList.indexOf(item) + 1 }}
              </div>
            </template>
            <template v-slot:[`item.start_time`]="{ item }">
              <div class="fontsize12px py-4">
                {{ new Date(item.start_time).toLocaleString() }}
              </div>
            </template>

            <template v-slot:[`item.end_time`]="{ item }">
              <div class="fontsize12px">
                {{ new Date(item.end_time).toLocaleString() }}
              </div>
            </template>
            <template v-slot:[`item.start_location`]="{ item }">
              <div v-if="item.start_location">
                {{ item.start_location }}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GetCurrentUserActivities } from "@/mixins/Methods/CurrentUserActivities.js";
import { DownloadExcel } from "@/mixins/Extras/DownloadExcel.js";
export default {
  props: {
    PoliceHistory: Boolean,
  },
  mixins: [GetCurrentUserActivities, DownloadExcel],
  data: () => ({
    search: "",
    height: 0,
    loadnig: false,
    Headers: [
      {
        text: "Sl.no",
        value: "sl_no",
      },
      {
        text: "Start time",
        value: "start_time",
      },
      {
        text: "End Time",
        value: "end_time",
      },
      {
        text: "Start Location",
        value: "start_location",
      },
      {
        text: "End Location",
        value: "end_location",
      },
      {
        text: "violation Sent",
        value: "violation_sent",
      },
    ],
  }),
  watch: {
    PoliceHistory(val) {
      if (val == true) {
        this.Get_CureentUser_Activities_Method();
      }
    },
  },
  mounted() {
    this.height = window.innerHeight - 210;
  },
  methods: {
    DownloadMyExcel() {
      let ModifiedData = this.GetActivitiesList.map((item) => {
        let object = { ...item };

        object.start_time = new Date(item.start_time).toLocaleString();
        object.end_time = new Date(item.end_time).toLocaleString();

        console.log("typeof item.violation_sent", typeof item.violation_sent);
        if (
          Array.isArray(item.violation_sent) &&
          item.violation_sent.length > 0
        ) {
          object.violation_sent = item.violation_sent[0];
        } else {
          object.violation_sent = item.violation_sent;
        }

        return object;
      });

      let excelHeader = this.Headers.map((header) => ({
        label: header.text,
        value: header.value,
      }));

      excelHeader.splice(0, 1);

      this.DownloadExcelMethod(excelHeader, ModifiedData, "Activity Report");
    },
    HistoryDialogEmit() {
      this.$emit("clicked");
    },
  },
};
</script>

<style></style>
